import { ReaderTaskData } from '@dynamika-shared/types/reader';

export const addFlagToLumbarSpine = (state: ReaderTaskData) => {
  if (state.scores) {
    const withFlag = state?.scores?.map(score =>
      score.bodyRegion === 'Lumbar Spine'
        ? { ...score, selected: false }
        : score
    );

    return { ...state, scores: withFlag };
  } else {
    return state;
  }
};
